module.exports = __webpack_public_path__ + "static/media/Nobody's Love.ba4d9f5c.txt";